define([
	"dojo/_base/declare",
	"csi",
	"csi/def/View",
	"csi/util",
], function(declare, csi, View, util) {

	return declare(View, {
		componentName: null,
		properties: null,

		constructor: function(def) {
			this.componentName = util.getProperty(def, 'Component');
			this.properties = csi.fromJson(util.getProperty(def, "ComponentParams", '{}'));
		}
	});
});